import styled, { css } from 'styled-components';
import { layout, remCalc } from 'src/components/base';
import type { LabelStyle } from './types';

type CheckboxProps = { disabled?: boolean };

export const Checkbox = styled.div<CheckboxProps>`
  user-select: none;
  font-weight: normal;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

export const Input = styled.input`
  appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;

type CheckIconWrapperProps = {
  checked?: boolean;
  partial?: boolean;
};

export const CheckIconWrapper = styled.span<CheckIconWrapperProps>(
  props => css`
    display: flex;
    border: 1px solid ${props.theme.lines.secondary};

    ${Input} {
      &:focus + & {
        border-color: ${props.theme.colors.maybeBlue700};
        outline: 1px solid ${props.theme.colors.maybeBlue700};
      }
    }

    svg {
      position: relative;
      left: 1px;
      top: 1px;
      stroke-width: 6px;
      path {
        stroke: ${props.theme.colors.base0};
        fill: none;
      }
    }

    ${(props.checked || props.partial) &&
    css`
      background-color: ${props.theme.colors.maybeBlue700};
      border-color: ${props.theme.colors.maybeBlue700};
      outline: 1px solid ${props.theme.colors.maybeBlue700};

      svg {
        background-color: ${props.theme.colors.maybeBlue700};
      }

      ${Input}:focus + & {
        background-color: ${props.theme.colors.maybeBlue700};
        border-color: ${props.theme.colors.maybeBlue700};
        outline: 2px solid ${props.theme.colors.maybeBlue700};
        svg {
          background-color: ${props.theme.colors.maybeBlue700};
        }
      }
    `};

    ${(props.checked || props.partial) &&
    css`
      svg {
        background-color: ${props.theme.lines.highlight};
      }
    `};
  `
);

type LabelTextProps = {
  labelStyle: LabelStyle;
};

export const LabelText = styled.span<LabelTextProps>`
  margin-left: ${layout.listSideMargin};
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.colors.base600};

  ${props =>
    props.labelStyle === 'bold' &&
    css`
      color: ${p => p.theme.text.callToAction};
      font-weight: 600;
    `}
`;

type LabelProps = { disabled?: boolean };

export const Label = styled.label<LabelProps>(
  props => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    position: relative;

    ${!props.disabled &&
    css`
      ${LabelText} {
        &:hover {
          color: ${props.theme.text.callToActionHover};
        }
      }
    `}

    ${props.disabled &&
    css`
      cursor: no-drop;
    `}
  `
);

type HelperProps = { warning?: boolean };
export const Helper = styled.span<HelperProps>`
  font-size: ${remCalc(12)};
  color: ${props =>
    props.warning
      ? props.theme.colors.negative700
      : props.theme.colors.base500};
  width: 100%;
`;
